import { SERVICE_CANCEL_HOST } from "../constant/url";

export const guid = () => {
  function _p8 (s: any) {
    const p = (Math.random().toString(16) + '000000000').substr(2, 8)
    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
  }

  return _p8(false) + _p8(true) + _p8(true) + _p8(false)
}

export const convertDateFormat = (option: string) => {
  return `${option?.substring(0, 4)}.${option?.substring(5, 7)}.${option?.substring(8, 10)}`
}

export const validInputLength = (inputValue: string, min: number) => {
  return inputValue.length < min ? true : false
}

/**
 * servicecancel이 포함되면 true 아니면 false
 */
export const isURLIncludeServiceCancel = () =>
  window.location.host.includes(SERVICE_CANCEL_HOST) ||
  window.location.host.includes("localhost");


//데스크탑 운영체제 체크
export const isDesktopOS = () => {
  const desktopPlatforms = [
    'win16',
    'win32',
    'win64',
    'windows',
    'mac',
    'macintel',
    'linux',
    'freebsd',
    'openbsd',
    'sunos',
  ]
  return desktopPlatforms.includes(navigator.platform.toLowerCase())
}

export function deviceDetection() {
  const userAgent = navigator.userAgent.toLowerCase()
  const isIOS = /iphone|ipad|ipod/.test(userAgent)
  // const isAndroid = /android/.test(userAgent)

  if (isIOS) {
    return 'IOS'
  } else {
    return 'AOS' // OS 구분이 어려운 경우 디폴트 안드로이드
  }
}